import { createLazyFileRoute } from "@tanstack/react-router";

import { LoadingPage } from "@/components/LoadingPage";
import { Tab, TabPanel, Tabs, TabsList } from "@/components/ui/tabs";
import { Text } from "@/components/ui/text";
import { useSettings } from "@/features/admin";
import { BillingSettings } from "@/features/admin/components/billing/BillingSettings";
import { InvoicesTable } from "@/features/admin/components/billing/InvoicesTable";
import { MasterInvoicesTable } from "@/features/admin/components/billing/MasterInvoicesTable";
import { Section } from "@/features/admin/components/Section";
import { useTabSearch } from "@/features/admin/hooks";

export const Route = createLazyFileRoute("/_auth/admin/billing/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { fetching, settings } = useSettings();
  const tabsProps = useTabSearch("invoices");

  return fetching ? (
    <LoadingPage />
  ) : (
    <>
      <Section.Title>Billing</Section.Title>
      <Tabs {...tabsProps} className="flex-1 flex flex-col min-h-0">
        <TabsList className="mb-4 w-full justify-start">
          <Tab id="invoices">Invoices</Tab>
          {settings.masterInvoiceEnabled === "true" && (
            <Tab id="master-invoices">Master Invoices</Tab>
          )}
          <Tab id="settings">Settings</Tab>
        </TabsList>
        <TabPanel id="invoices" className="flex flex-col flex-1 min-h-0">
          <InvoicesTable />
        </TabPanel>
        <TabPanel id="master-invoices" className="flex flex-col flex-1 min-h-0">
          {settings.masterInvoiceEnabled === "true" ? (
            <MasterInvoicesTable />
          ) : (
            <Text>Master invoices are not enabled</Text>
          )}
        </TabPanel>
        <TabPanel id="settings" className="flex flex-col flex-1">
          <BillingSettings />
        </TabPanel>
      </Tabs>
    </>
  );
}
